import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import { Typewriter } from './typewriter'

new BlockModule({
    selector: '.egnc-url-typewriter',
    vueComponent: defineComponent({
        components: {
            TypewriterComponent: Typewriter,
        },
        setup() {},
    }),
})
